import { __assign } from "tslib";
import { HarmonyThemeIdContext } from '@1js/office-start-style-utility';
import { FluentProvider, IdPrefixProvider, } from '@fluentui/react-components';
import { ThemeContext_unstable } from '@fluentui/react-shared-contexts';
import { isHarmonyThemeId as isHarmonyThemeIdFunc, mergeThemes, ThemeModeContext, useGlobalTheme, useGlobalThemeMode, useThemeId, useThemeMode, } from '@office-start/theming-service';
import React, { useContext, useMemo } from 'react';
export var OfficeFluentProvider = function (props) {
    var globalTheme = useGlobalTheme();
    var globalThemeMode = useGlobalThemeMode();
    var isFluentContext = useContext(ThemeContext_unstable);
    var parentThemeMode = useThemeMode();
    var fluentTheme = useMemo(function () {
        return isFluentContext
            ? props.theme
            : mergeThemes(globalTheme, props.theme);
    }, [globalTheme, isFluentContext, props.theme]);
    var mode = props.themeMode || parentThemeMode || globalThemeMode;
    var dir = (props.dir || document.dir || undefined);
    var themeId = useThemeId();
    var isHarmonyThemeId = isHarmonyThemeIdFunc(themeId !== null && themeId !== void 0 ? themeId : '');
    return (React.createElement(IdPrefixProvider, { value: "ohp-" },
        React.createElement(FluentProvider, __assign({}, props, { theme: fluentTheme, dir: dir }),
            React.createElement(ThemeModeContext.Provider, { value: mode },
                React.createElement(HarmonyThemeIdContext.Provider, { value: isHarmonyThemeId }, props.children)))));
};
//# sourceMappingURL=OfficeFluentProvider.js.map